import { NgModule } from '@angular/core';
import { MerchantCategoriesService } from './merchant-categories.service';
import { MerchantService } from './merchant.service';
import { BlockTablesModalComponent } from 'OpsCenter/merchants/areas/block-tables-modal/block-tables-modal.component';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [BlockTablesModalComponent],
  entryComponents: [BlockTablesModalComponent],
  providers: [MerchantCategoriesService, MerchantService],
  imports: [
    SharedModule,
    CommonModule,
  ],
})

/** @desc Migrated merchants module to handle merchant logic **/
export class MerchantsModule {}



// WEBPACK FOOTER //
// ./src/app/merchants/merchants.module.ts